import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';
import { CellData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

import { ScenarioService } from '../services/scenario.service';

@Component({
	selector: 'sc-scenario',
	templateUrl: './scenario.component.html',
	styleUrls: ['./scenario.component.scss']
})
export class ScenarioComponent implements OnInit {
	@Input() public scenario: CellData;
	@Input() public isSelected: boolean = false;
	@Input() public showInfoBubbles: boolean = false;
	@Output() public onSelect: EventEmitter<any> = new EventEmitter<any>();
	@Output() public onDeselect: EventEmitter<any> = new EventEmitter<any>();

	public imagesPath: SafeStyle;

	constructor(private scenarioService: ScenarioService) { }

	public ngOnInit(): void {
		const scenario = get(this.scenario, 'rawValue');
		this.imagesPath = this.scenarioService.getImagePath(scenario);
	}

	public onScenarioSelectionClick(event: MouseEvent): void {
		const el = <HTMLInputElement>event.currentTarget;
		if (el.checked) {
			this.onSelect.emit();
		} else {
			this.onDeselect.emit();
		}
	}
}
